import { Component, OnInit, OnDestroy } from '@angular/core';
import { CategoryService, ProductService } from '@app/api/api';
import { Subscription, Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { UtilService } from '@app/services/util.service';
import { Router } from '@angular/router';
@Component({
  selector: 'meu-app-home-product-by-category',
  templateUrl: './app-home-product-by-category.component.html',
  styleUrls: ['./app-home-product-by-category.component.scss'],
})
export class AppHomePageProductByCategoryComponent implements OnInit, OnDestroy {
  listCategoriesAndproduct = [];
  loading = true;
  page = 1;
  pageSize = 264;
  productPage = 1;
  productPageSize = 8;
  host = environment.backendhost;
  private subscriptions: Subscription[] = [];
  constructor(private categoryService: CategoryService, private router: Router) {}

  // getCategoriesAndProduct() {
  //   const sub = this.categoryService
  //     .apiCategoriesWithProductsGet(
  //       this.page,
  //       this.pageSize,
  //       this.productPage,
  //       this.productPageSize
  //     )
  //     .subscribe((res) => {
  //       if (res.success) {
  //         this.listCategoriesAndproduct = res.data.collection.filter((item) => {
  //           return item.products.collection.length >= 8;
  //         });
  //       }
  //       this.loading = false;
  //     });
  //   this.subscriptions.push(sub);
  // }

  getCategoriesAndProduct() {
    const sub = this.categoryService.apiCategoriesWithProductsAllGet().subscribe((res) => {
      if (res.success) {
        this.listCategoriesAndproduct = res.data.collection.filter((item) => {
          return item.productCount >= 8;
        });
      }
      this.loading = false;
    });

  }
  getProductByCategory(item) {
    this.router.navigate(['/searchbycategory'], {
      queryParams: {
        categoryId: item.id,
        categoryName: UtilService.slugify(item.name),
      },
    });
  }
  goToProductDetails(product: any) {
    this.router.navigate(['/product', product.id, UtilService.slugify(product.name), 'details']);
  }

  ngOnInit() {
    this.getCategoriesAndProduct();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
